import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('Opinions/getAll');
    const { statusData } = useEntityCrud('Opinions/ChangeStatus');

    const [rows, setRows] = useState([]);

    const { readData :readDataOptions } = useEntityCrud('Guild/GetAllGuilds');
    const [options, setOptions] = useState([]);

    useEffect(() => {
        readDataOptions().then(({ data }) => {
            if (data.status) {
                let guilds = data.result.filter(item => item.isActive);
                setOptions(guilds);
            }
        });
    }, []);

    const getData = () => {
        readData().then(({ data }) => {
            if (data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getData();
    }, [])


    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        return shamsiDate
    }


    const deActiveRow = (id, title) => {
        const postedData = {
            id,
            status: false,
            title: title
        };
        statusData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success(' نظرسنجی مورد نظر با موفقیت  غیرفعال شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = (id, title) => {
        const postedData = {
            id,
            status: true,
            title: title
        };
        statusData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success(' نظرسنجی مورد نظر با موفقیت  فعال شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }



     return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">نظرسنجی</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد نظرسنجی</Link> : ''}
                {context.checkHasPermission('create') ? <Link className="btn btn-secondary mx-2" to="sms">ثبت متن پیامک</Link> : ''}
                {context.checkHasPermission('create') ? <hr /> : ''}
                {rows.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                             <th>عنوان</th>
                            <th>صنف</th>
                            <th>از تاریخ</th>
                            <th>تا تاریخ</th>
                            <th>بازه ی زمانی   </th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                 <td>{item.title || '-'}</td>
                                <td>{options?.find(option => option.id === item.guildId)?.title || '-'}</td>
                                <td>{convertDateToInputValue(item.fromdate) || '-'}</td>
                                <td>{convertDateToInputValue(item.todate) || '-'}</td>
                                <td>{item.issueDay !== 0 ? item.issueDay + " روز " : 'تعریف نشده است'}</td>
                                <td className="btn-list">
                                {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('delete') ? (item.status ? <button onClick={e => deActiveRow(item.id, item.title)}
                                        className="btn btn-icon mb-0 btn-danger"><i className="fe fe-x"></i></button>
                                        : <button onClick={e => activeRow(item.id, item.title)} className="btn btn-icon mb-0 btn-success">
                                            <i className="fe fe-check"></i></button>) : ''}
                                    <Link to={'/survey/surveyQuestion/' + item.id} className="btn btn-icon mb-0 btn-info px-4">
                                        <i className="fe fe-list"></i>             لیست پرسش ها</Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {rows.length}</p>
                </div> : <div className="alert alert-info"><p>نظرسنجی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;